import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  company: [],
  positionGroup: [],
  imported: false,
  filterCompany: [],
  filterPosition: [],
  loadingStates: []
}

const fetchPositionStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchPositionSuccess = (state, action) => {
  let { records } = action
  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name
    }
  })
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    pagination: action.pagination,
    records
  }
}

const fetchPositionFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    errorMessage: action.errorMessage
  }
}

const fetchPositionByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedPositionRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: null,
    success: false
  }
}

const createPositionStart = (state, action) => {
  return { ...state, loading: true }
}

const createPositionSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createPositionFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updatePositionStart = (state, action) => {
  return { ...state, loading: true }
}

const updatePositionSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updatePositionFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deletePositionStart = (state, action) => {
  return { ...state, loading: true }
}

const deletePositionSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deletePositionFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchPositionGroupStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchPositionGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    positionGroup: action.data
  }
}

const fetchPositionGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchPositionFilterCompanyStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchPositionFilterCompanySuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterCompany: action.data
  }
}

const fetchPositionFilterCompanyFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchPositionFilterPositionStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchPositionFilterPositionSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    filterPosition: action.data
  }
}

const fetchPositionFilterPositionFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const importPositionStart = (state, action) => {
  return {
    ...state,
    importLoading: true,
    imported: false
  }
}

const importPositionSuccess = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: true
  }
}

const importPositionFailed = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: false
  }
}

const exportPositionStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const exportPositionSuccess = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const exportPositionFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const downloadPositionTemplateStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const downloadPositionTemplateSuccess = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const downloadPositionTemplateFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_POSITION_START:
      return fetchPositionStart(state, action)
    case actionTypes.FETCH_POSITION_SUCCESS:
      return fetchPositionSuccess(state, action)
    case actionTypes.FETCH_POSITION_BY_ID_SUCCESS:
      return fetchPositionByIdSuccess(state, action)
    case actionTypes.FETCH_POSITION_FAILED:
      return fetchPositionFailed(state, action)
    case actionTypes.CLEAR_SELECTED_POSITION_RECORD:
      return clearSelectedPositionRecord(state, action)
    case actionTypes.CREATE_POSITION_START:
      return createPositionStart(state, action)
    case actionTypes.CREATE_POSITION_SUCCESS:
      return createPositionSuccess(state, action)
    case actionTypes.CREATE_POSITION_FAILED:
      return createPositionFailed(state, action)
    case actionTypes.UPDATE_POSITION_START:
      return updatePositionStart(state, action)
    case actionTypes.UPDATE_POSITION_SUCCESS:
      return updatePositionSuccess(state, action)
    case actionTypes.UPDATE_POSITION_FAILED:
      return updatePositionFailed(state, action)
    case actionTypes.DELETE_POSITION_START:
      return deletePositionStart(state, action)
    case actionTypes.DELETE_POSITION_SUCCESS:
      return deletePositionSuccess(state, action)
    case actionTypes.DELETE_POSITION_FAILED:
      return deletePositionFailed(state, action)
    case actionTypes.IMPORT_POSITION_START:
      return importPositionStart(state, action)
    case actionTypes.IMPORT_POSITION_SUCCESS:
      return importPositionSuccess(state, action)
    case actionTypes.IMPORT_POSITION_FAILED:
      return importPositionFailed(state, action)
    case actionTypes.EXPORT_POSITION_START:
      return exportPositionStart(state, action)
    case actionTypes.EXPORT_POSITION_SUCCESS:
      return exportPositionSuccess(state, action)
    case actionTypes.EXPORT_POSITION_FAILED:
      return exportPositionFailed(state, action)
    case actionTypes.DOWNLOAD_POSITION_TEMPLATE_START:
      return downloadPositionTemplateStart(state, action)
    case actionTypes.DOWNLOAD_POSITION_TEMPLATE_SUCCESS:
      return downloadPositionTemplateSuccess(state, action)
    case actionTypes.DOWNLOAD_POSITION_TEMPLATE_FAILED:
      return downloadPositionTemplateFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_START:
      return fetchPositionGroupStart(state, action)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_SUCCESS:
      return fetchPositionGroupSuccess(state, action)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_FAILED:
      return fetchPositionGroupFailed(state, action)
    case actionTypes.FETCH_POSITION_FILTER_COMPANY_START:
      return fetchPositionFilterCompanyStart(state, action)
    case actionTypes.FETCH_POSITION_FILTER_COMPANY_SUCCESS:
      return fetchPositionFilterCompanySuccess(state, action)
    case actionTypes.FETCH_POSITION_FILTER_COMPANY_FAILED:
      return fetchPositionFilterCompanyFailed(state, action)
    case actionTypes.FETCH_POSITION_FILTER_POSITION_START:
      return fetchPositionFilterPositionStart(state, action)
    case actionTypes.FETCH_POSITION_FILTER_POSITION_SUCCESS:
      return fetchPositionFilterPositionSuccess(state, action)
    case actionTypes.FETCH_POSITION_FILTER_POSITION_FAILED:
      return fetchPositionFilterPositionFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
